//Entry point
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import { store, bindActionCreators } from './app.store.jsx';
import { initNavigationPages } from './app.reducer.jsx';
import i18n from './i18n.jsx';
import ApplicationLayout from './layout/base/application.layout.jsx';
import config from './config/cancer.questionnaire.config.jsx';
import questionnaireConstructor from './engine/constructor.jsx';
import { getQuestionnaireToken, mapPageToNavigationElement } from './questionnaire.utils.jsx';
import { fetchInitialData } from './loader/actions.jsx';
const Questionnaire = questionnaireConstructor(config);
import PublicLinkLayout from './layout/base/public.link.layout.jsx';
const APPLICATION_MOUNT_NODE = document.getElementById('application-mount-point');
const PUBLIC_LINK_MOUNT_NODE = document.getElementById('public-link-mount-node');
const CSRF_TOKEN = document.getElementsByName('csrfmiddlewaretoken');
const _ = i18n;
const DUMMY_TOKEN = 'dummy-token';
const TOKEN = getQuestionnaireToken();
const isPublicLinkPage = DUMMY_TOKEN === TOKEN;
if (TOKEN && !isPublicLinkPage) { store.dispatch(fetchInitialData(TOKEN)); }

class ApplicationLoaderPlaceholder extends Component {
    render() {
        return (
            <div>
                { _('Questionnaire is loading, please wait...') }
            </div>
        );
    }
}

class ApplicationWrapper extends Component {
    render() {
        const { token, fields, height, width, headerLink, language, pedigreeGenerated, errorText } = this.props;
        const { navigationPageList, pageList, lastPageIndex, currentPageIndex } = this.props.pages.toJS();
        const props = { errorText, pedigreeGenerated, language, token, headerLink, navigationPageList, fields, height, width, pageList, lastPageIndex, currentPageIndex, components: this.props.components.toJS() };
        if (this.props.dataLoaded) {
            return (
                <ApplicationLayout {...props}>
                    <Questionnaire {...props}/>
                </ApplicationLayout>
            );
        }
        return <ApplicationLoaderPlaceholder/>;
    }
}

class PublicLinkWrapper extends Component {
    constructor() {
        super();
        this._initNavigationPages = bindActionCreators(initNavigationPages);
    }
    componentDidMount() {
        const parsedConfig = 'string' === typeof config ? JSON.parse(config) : config;
        const pages = parsedConfig.childrenNodes;
        this._initNavigationPages(pages.map(mapPageToNavigationElement));
    }
    render() {
        const headerLink = this.props.headerLink;
        const { navigationPageList, pageList } = this.props.pages.toJS();
        const props = { headerLink, navigationPageList, staticLeftBar: true, pageList, csrf: CSRF_TOKEN } ;
        return <PublicLinkLayout {...props} />;
    }
}
const MOUNT_NODE = isPublicLinkPage ? PUBLIC_LINK_MOUNT_NODE : APPLICATION_MOUNT_NODE;
const QuestionnaireApplication = connect((state) => state)(ApplicationWrapper);
const PublicLink = connect((state) => state)(PublicLinkWrapper);
ReactDOM.render(
    <Provider store={store}>
        { isPublicLinkPage ? <PublicLink /> : <QuestionnaireApplication /> }
    </Provider>,
    MOUNT_NODE
);
